import React from "react";
import styled from "styled-components";
import { GestureVideo } from "components/pages/Session/shared/GestureVideo/GestureVideo";
import { useMembers } from "hooks/livekit/useMembers/useMembers";

export const VideosBar = ({
  videoWidget,
  includeObservers = false,
  isSpectator,
}) => {
  const { members } = useMembers({ includeObservers });
  const VideoWidget = videoWidget;

  return (
    <Wrapper>
      {members.map(({ participant, isLocalParticipant }, index) => (
        <React.Fragment key={participant.sid}>
          {isSpectator ? (
            <ObserverVideoContainer>
              {videoWidget && <VideoWidget participant={participant} />}
              <GestureVideo
                participant={participant}
                isLocalParticipant={isLocalParticipant}
                isSpectator={isSpectator}
                participantIndex={index}
              />
            </ObserverVideoContainer>
          ) : (
            <VideoContainer>
              {videoWidget && <VideoWidget participant={participant} />}
              <GestureVideo
                participant={participant}
                isLocalParticipant={isLocalParticipant}
                isSpectator={isSpectator}
                participantIndex={index}
              />
            </VideoContainer>
          )}
        </React.Fragment>
      ))}
    </Wrapper>
  );
};

const gutter = 8;
const maxHeight = 180;
const ratio = 16 / 9;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  padding-top: ${gutter}px;
  padding-bottom: ${gutter}px;
`;

const VideoContainer = styled.div`
  position: relative;
  max-height: ${maxHeight}px;
  width: calc(50% - 12px);
  max-width: ${(maxHeight - gutter * 2) * ratio}px;
`;

const ObserverVideoContainer = styled.div`
  position: relative;
  max-height: ${maxHeight}px;
  width: 100%;
  margin: 0px ${gutter / 2}px;
`;
